import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { LiaFileContractSolid } from "react-icons/lia";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import SearchBar from "../../../common/Search";
import CustomPagination from "../../../components/Common/CustomPagination.js";
import CustomShowModal from "../../../components/Common/CustomShowModal.js";
import { getObject, getOrganizationId, toastError, toastSuccess } from "../../../utils.js";
import { createEstimateContract } from "../Calculator/actions.js";
import {
  initialContractFields,
  initialVesselContractFields,
} from "../Calculator/Contracts/index.js";
import { updateUser } from "../Dashboard/actions.js";
import { createVesselContract } from "../Fleet/action.js";
import { createCargoContract } from "../Orders/actions.js";
import { getAllEstimate } from "./action.js";
import { EstimateToContractStepper } from "./estimateTocontractStepper.js";

const Allmatrix = (props) => {
  const { loader, setLoader = () => { } } = props;
  const [modelType, setModelType] = useState("");
  const user = getObject("auth");
  const organizationId = getOrganizationId();
  const [searchValue, setSearchValue] = useState("");
  const [allEstimate, setAllEstimates] = useState([]);
  const [isStepperOpen, setIsStepperOpen] = useState(false);
  const [selectedEstimate, setSelectedEstimate] = useState({});
  const [vesselAttachments, setVesselAttachments] = useState([]);
  const [cargoAttachments, setCargoAttachments] = useState([]);
  const [cargoTextContract, setCargoTextContract] = useState();
  const [vesselTextContract, setVesselTextContract] = useState();
  const [estimateFormData, setEstimateFormData] = useState({});
  const [cargoFormData, setCargoFormData] = useState(initialContractFields);
  const [vesselFormData, setVesselFormData] = useState(
    initialVesselContractFields
  );
  const [filters, setFilters] = useState({
    offset: 1,
    limit: 50,
    totalPages: 0,
    totalItems: 0,
    startDate: "",
    endDate: "",
    sortBy: "createdAt",
    sortDirection: "desc",
  });

  const [reason, setReason] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason === "") {
      toastError("Please write a reason");
      return
    }
    const requestData = {
      reason: reason,
      section: "all matrix",
      createdAt: new Date().toISOString(),
    };

    updateUser({ request: requestData })
      .then((res) => {
        toastSuccess('Request submited successfully');
        setReason("");
      })
      .catch((err) => {
        console.error('Error updating user details:', err);
        toastError('Error updating user details');
      });
  };


  const fetchEstimateData = async ({ startDate, endDate, search, passedFilters }) => {
    try {
      setLoader(true);
      const activeFilters = passedFilters || filters;
      const { offset, limit, sortBy, sortDirection } = activeFilters;
      const data = await getAllEstimate(
        { page: offset, limit, sortBy, sortDirection },
        { startDate, endDate, search }
      );
      setAllEstimates(data.data);

      // Update pagination information from response
      setFilters((prev) => ({
        ...prev,
        totalPages: data.totalPages || prev.totalPages,
        totalItems: data.totalItems || prev.totalItems,
      }));

      setLoader(false);
      return data;
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const onSearchVessel = async (search) => {
    await fetchEstimateData({
      search,
      startDate: filters.startDate ? filters.startDate.toISOString() : "",
      endDate: filters.endDate ? filters.endDate.toISOString() : "",
    });
  };

  const delaySearch = useCallback(
    _.debounce((data) => onSearchVessel(data), 500),
    []
  );

  const onSearchChange = (e) => {
    setSearchValue(e.target.value);
    delaySearch(e.target.value);
  };

  const handleDateRangeChange = async (newDateRange) => {
    const { startDate, endDate } = newDateRange;

    const formattedStartDate = startDate?.toISOString() || "-";
    const formattedEndDate = endDate?.toISOString() || "-";

    setFilters((prev) => ({
      ...prev,
      startDate,
      endDate,
    }));

    await fetchEstimateData({
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      search: searchValue,
    });
  };

  const handleSortClick = (sortKey) => {
    let newSortDirection = "asc";

    if (filters.sortBy === sortKey) {
      if (filters.sortDirection === "asc") newSortDirection = "desc";
      else if (filters.sortDirection === "desc") {
        newSortDirection = sortKey === "createdAt" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdAt" ? "desc" : "asc";
    }

    let apiFilters = { ...filters, sortBy: sortKey, sortDirection: newSortDirection, offset: 1 };
    if (!newSortDirection) {
      apiFilters.sortBy = "createdAt";
      apiFilters.sortDirection = "desc";
    }

    setFilters(apiFilters);
    fetchEstimateData({
      search: searchValue,
      startDate: apiFilters.startDate,
      endDate: apiFilters.endDate,
      passedFilters: apiFilters
    });
  };

  useEffect(() => {
    const loadAllEstimates = async () => {
      const res = await fetchEstimateData({
        search: searchValue,
        startDate: filters.startDate,
        endDate: filters.endDate,
      });
      if (res) {
        setFilters((prev) => ({
          ...prev,
          totalItems: res.totalItems || 0,
          totalPages: res?.totalPages || 0,
        }));
      }
    };

    loadAllEstimates();
  }, [filters.offset]);

  const handlePagination = (action, type) => {
    let newPage = filters.offset;
    if (action === "first") {
      newPage = 1;
    } else if (action === "dec") {
      if (filters.offset > 1) {
        newPage = filters.offset - 1;
      }
    } else if (action === "inc") {
      if (filters.offset < filters?.totalPages) {
        newPage = filters.offset + 1;
      }
    } else if (action === "last") {
      newPage = filters?.totalPages;
    }

    if (newPage !== filters.offset) {
      setFilters((prev) => ({
        ...prev,
        offset: newPage,
      }));
    }
  };

  const handleOpenEstimateCalc = async ({ _id, type }) => {
    if (type === "vessel-vessel") {
      window.open(`/vessel-vessel/estimation/${_id}`, "_blank");
    } else if (type === "cargo-cargo") {
      window.open(`/cargo-cargo/estimation/${_id}`, "_blank");
    } else {
      window.open(`/saved/${_id}`, "_blank");
    }
  };

  const handleVesselAttachmentUpload = async (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setVesselAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };

  const handleCargoAttachmentUpload = async (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }

      setCargoAttachments((prev) => [...(Array.isArray(prev) ? prev : []), ...validFiles]);
    }
  };
  const handleVesselDataChange = (e) => {
    const { name, value } = e.target;
    setVesselFormData({
      ...vesselFormData,
      [name]: value,
    });
  };
  const handleCargoDataChange = (e) => {
    const { name, value } = e.target;
    setCargoFormData({
      ...cargoFormData,
      [name]: value,
    });
  };

  const handleVesselTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setVesselTextContract(e.target.files[0]);
    }
  };

  const handleCargoTextContractUpload = (e) => {
    if (e.target.files[0]) {
      setCargoTextContract(e.target.files[0]);
    }
  };

  const removeCargoAttachment = (index) => {
    setCargoAttachments((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      return list.filter((_, i) => i !== index);
    });
  };

  const removeVesselAttachment = (index) => {
    setVesselAttachments((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      return list.filter((_, i) => i !== index);
    });
  };

  const handleOpenModelForCreateContract = async (data) => {
    const { type, ...rest } = data;
    if (type === "vessel-vessel") {
      const vesselDetails = rest?.fleetList[0] || rest;
      const cargoDetails = rest?.clientQuery;
      setSelectedEstimate({ vesselDetails, cargoDetails });
      setCargoFormData((prev) => ({ ...prev, cargoList: rest?.clientQuery?.cargoList || [] }))
      setModelType(type);
      setIsStepperOpen(true);
    } else {
      setSelectedEstimate(rest);
      setCargoFormData((prev) => ({ ...prev, cargoList: (rest?.customerCargo?.cargoList ?? rest?.clientQuery?.cargoList ?? []) }))
      setModelType(type);
      setIsStepperOpen(true);
    }
  };

  const setInitialState = () => {
    setIsStepperOpen(false);
    setSelectedEstimate({})
    setVesselFormData(initialVesselContractFields);
    setCargoFormData(initialContractFields);
    setEstimateFormData()
    setCargoAttachments([]);
    setCargoTextContract();
    setVesselTextContract();
    setVesselAttachments([]);
  };

  const createFormData = (textContract, attachments, payload) => {
    const formData = new FormData();

    if (textContract) {
      const fileType = textContract.type || "application/octet-stream";
      const fileName = textContract.name || "contract.txt";
      const textFile = new File(
        [new Blob([textContract], { type: fileType })],
        fileName,
        { type: fileType }
      );

      formData.append("files", textFile);
      formData.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    attachments?.forEach((file) => formData.append("files", file));
    formData.append("data", JSON.stringify(payload));

    return formData;
  };
  const saveCargoContract = async () => {
    try {
      const { cargoList, ...rest } = cargoFormData;

      // figure out which key exists
      const cargoKey = selectedEstimate?.customerCargo
        ? "customerCargo"
        : selectedEstimate?.clientQuery
          ? "clientQuery"
          : null;

      const cargoPayload = {
        ...rest,
        organizationId,
        cargoId: selectedEstimate._id,
        cargoDetails: cargoKey && {
          ...selectedEstimate,
          [cargoKey]: {
            ...selectedEstimate[cargoKey],
            cargoList,
          },
        },
        contractType: modelType,
        status: "close",
      };

      if (!cargoPayload.contractName) {
        toastError('Contract Name is Required')
        return
      }

      const formPayload = createFormData(
        cargoTextContract,
        cargoAttachments,
        cargoPayload
      );

      // Create vessel contract
      const { cargoContract } = await createCargoContract(formPayload);

      if (!cargoContract) {
        return toastError("Cargo contract creation failed.");
      }

      // Create estimate contract
      const contractEstimatePayload = {
        ...estimateFormData,
        cargoContractId: cargoContract._id,
        organizationId,
        cargoContractDetails: cargoContract,
        contractType: modelType,
        status: 'open'
      };

      await createEstimateContract(contractEstimatePayload);
      toastSuccess("Contract created successfully.");
      setInitialState();
    } catch (error) {
      toastError(error?.message || "Something went wrong.");
    }
  };

  const saveVesselContract = async () => {
    try {
      const basePayload = { organizationId };
      const { vesselDetails, cargoDetails } = selectedEstimate;

      const vesselContractPayload = {
        ...basePayload,
        ...vesselFormData,
        vesselId: vesselDetails._id,
        vesselDetails: {
          ...vesselDetails,
          clientQuery: {
            ...cargoDetails,
          }
        },
        contractType: modelType,
        status: "close",
      };

      if (!vesselContractPayload.contractName) {
        toastError("Vessel Contract Name is Required");
        return;
      }

      const vesselFormPayload = createFormData(
        vesselTextContract,
        vesselAttachments,
        vesselContractPayload
      );

      const vesselContractData = await createVesselContract(vesselFormPayload);

      if (!vesselContractData?.vesselContract?._id) {
        throw new Error("Vessel contract creation failed");
      }

      if (estimateFormData) {
        const vesselContractId = vesselContractData.vesselContract._id;

        const estimateContractPayload = {
          ...basePayload,
          ...estimateFormData,
          vesselContractId,
          vesselContractDetails: vesselContractData.vesselContract,
          contractType: modelType,
        };

        if (!estimateContractPayload.contractName) {
          toastError("Estimate Contract Name is Required");
          return;
        }

        const estimateContractData = await createEstimateContract(
          estimateContractPayload
        );

        if (!estimateContractData) {
          throw new Error("Estimate contract creation failed");
        }

        toastSuccess("Contract Created Successfully");
        setInitialState();
      }

      return true;
    } catch (error) {
      toastError(error.message || "Contract creation failed");
      return false;
    }
  };

  const saveCargoVesselContract = async () => {
    try {

      // Prepare base payloads
      const basePayload = { organizationId };
      const vesselDetails = selectedEstimate?.calculatedFleetResult?.fleetList?.[0] ?? selectedEstimate?.calculatedFleetResult;
      // Prepare vessel contract payload and form data
      const vesselContractPayload = {
        ...basePayload,
        ...vesselFormData,
        vesselDetails,
        vesselId: vesselDetails?._id,
        contractType: modelType,
        status: 'close'
      };
      if (!vesselContractPayload.contractName) {
        toastError('Vessel Contract Name is Required')
        return
      }

      const vesselFormPayload = createFormData(
        vesselTextContract,
        vesselAttachments,
        vesselContractPayload
      );

      // Create vessel contract
      const vesselContractData = await createVesselContract(vesselFormPayload);
      if (!vesselContractData?.vesselContract?._id) {
        throw new Error("Vessel contract creation failed");
      }

      const { cargoList, ...rest } = cargoFormData;

      // Prepare cargo contract payload and form data
      const cargoContractPayload = {
        ...basePayload,
        ...rest,
        cargoDetails: {
          ...selectedEstimate?.clientQuery,
          cargoList,
        },
        cargoId: selectedEstimate?.clientQuery?._id,
        contractType: modelType,
        status: 'close'
      };

      if (!cargoContractPayload.contractName) {
        toastError('Cargo Contract Name is Required')
        return
      }

      const cargoFormPayload = createFormData(
        cargoTextContract,
        cargoAttachments,
        cargoContractPayload
      );

      // Create cargo contract
      const cargoContractData = await createCargoContract(cargoFormPayload);
      if (!cargoContractData?.cargoContract?._id) {
        throw new Error("Cargo contract creation failed");
      }

      // Create estimate contract if form data exists
      if (estimateFormData) {
        const vesselContractId = vesselContractData.vesselContract._id;
        const cargoContractId = cargoContractData.cargoContract._id;

        const estimateContractPayload = {
          ...basePayload,
          ...estimateFormData,
          cargoContractId,
          vesselContractId,
          vesselContractDetails: vesselContractData.vesselContract,
          cargoContractDetails: cargoContractData.cargoContract,
          contractType: modelType,
        };
        if (!estimateContractPayload.contractName) {
          toastError('Estmiate Contract Name is Required')
          return
        }
        const estimateContractData = await createEstimateContract(
          estimateContractPayload
        );
        if (!estimateContractData) {
          throw new Error("Estimate contract creation failed");
        }

        toastSuccess("Contract Created Successfully");
        setInitialState();
      }

      return true;
    } catch (error) {
      toastError(error.message || "Contract creation failed");
      return false;
    }
  };
  const handleStepperSubmit = async () => {
    if (modelType === "cargo-cargo") {
      await saveCargoContract();
    } else if (modelType === "vessel-vessel") {
      await saveVesselContract();
    } else {
      await saveCargoVesselContract();
    }
  };

  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Box className="w-full flex justify-center">
        <div className="hidden md:block w-fit">
          <SearchBar
            onDateRangeChange={handleDateRangeChange}
            placeholder={"Search with Voyage Label or Voyage Name..."}
            setSearchValue={onSearchChange}
            searchValue={searchValue}
          />
        </div>
      </Box>
      <Box className="md:hidden" display="flex" justifyContent="center" mt={2}>
        <div className="w-full"><SearchBar
          isMobile
          onDateRangeChange={handleDateRangeChange}
          placeholder={"Search with Voyage Label or Voyage Name..."}
          setSearchValue={onSearchChange}
          searchValue={searchValue}
        /></div>
      </Box>
      <TableContainer component={Paper} className="mt-4" style={{ minHeight: (loader || !allEstimate?.length) ? "500px" : "auto", overflow: loader ? "hidden" : "auto" }}>
        {filters?.totalItems > filters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={filters}
            totalPage={filters?.totalItems}
          />
        )}
        <Table className="universal-table fit-content-mobile">
          <TableHead>
            <TableRow>
              <TableCell>No.</TableCell>
              <TableCell style={{ cursor: "pointer" }} onClick={() => handleSortClick("type")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Type
                  <div style={{ color: filters.sortBy === "type" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {filters.sortBy === "type" && filters.sortDirection === "desc" ? <LuArrowDown size={14} /> : filters.sortBy === "type" && filters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell style={{ cursor: "pointer" }} onClick={() => handleSortClick("estimateLabel")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Estimate Label
                  <div style={{ color: filters.sortBy === "estimateLabel" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {filters.sortBy === "estimateLabel" && filters.sortDirection === "desc" ? <LuArrowDown size={14} /> : filters.sortBy === "estimateLabel" && filters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell>Estimation ID</TableCell>
              <TableCell style={{ cursor: "pointer" }} onClick={() => handleSortClick("vesselName")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Vessel Name
                  <div style={{ color: filters.sortBy === "vesselName" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {filters.sortBy === "vesselName" && filters.sortDirection === "desc" ? <LuArrowDown size={14} /> : filters.sortBy === "vesselName" && filters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell>First Load Port</TableCell>
              <TableCell>Last Discharge Port</TableCell>
              <TableCell style={{ cursor: "pointer" }} onClick={() => handleSortClick("createdAt")}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Created at
                  <div style={{ color: filters.sortBy === "createdAt" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                    {filters.sortBy === "createdAt" && filters.sortDirection === "desc" ? <LuArrowDown size={14} /> : filters.sortBy === "createdAt" && filters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                  </div>
                </div>
              </TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loader ? (
              <TableRow>
                <TableCell colSpan={10} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                    {allEstimate?.length > 0 && <CircularProgress />}
                  </Box>
                </TableCell>
              </TableRow>
            ) : allEstimate?.length ? (
              allEstimate?.map((val, index) => {
                const estimateLabel = val.estimateLabel;
                const vesselName = val.vesselName;
                const firstPort = val.firstPort;
                const lastPort = val.lastPort;
                return (
                  <TableRow
                    key={index}
                    className="hover:bg-gray-50 cursor-pointer"
                    onDoubleClick={() =>
                      handleOpenEstimateCalc({ _id: val._id, type: val.type })
                    }
                  >
                    <TableCell>{(filters.offset - 1) * filters.limit + index + 1}</TableCell>
                    <TableCell>
                      <button>{val?.type || "-"}</button>
                    </TableCell>
                    <TableCell>
                      <button
                        className="underline text-blue"
                        onClick={() =>
                          handleOpenEstimateCalc({ _id: val._id, type: val.type })
                        }
                      >
                        {estimateLabel || "-"}
                      </button>
                    </TableCell>
                    <TableCell>
                      <button>{val?.estId || "-"}</button>
                    </TableCell>
                    <TableCell>
                      <button>{vesselName || "-"}</button>
                    </TableCell>
                    <TableCell>
                      <button>{firstPort || "-"}</button>
                    </TableCell>
                    <TableCell>
                      <button>{lastPort || "-"}</button>
                    </TableCell>
                    <TableCell>
                      <button>
                        {moment(val?.createdAt || val.createdDate).format(
                          "DD-MM-YYYY"
                        )}
                      </button>
                    </TableCell>
                    <TableCell>
                      <button>{val?.createdUserName || "-"}</button>
                    </TableCell>
                    <TableCell>
                      <>
                        <span className="pending-steper validate-icon-vessel-manager border-none">
                          <LiaFileContractSolid
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => handleOpenModelForCreateContract(val)}
                          />
                        </span>
                        <div className="tooltip-notification-vessel-manager">
                          <p>Create Contract</p>
                        </div>
                      </>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No Data Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filters?.totalItems > filters?.limit && (
          <CustomPagination
            onChangePagination={handlePagination}
            filters={filters}
            totalPage={filters?.totalItems}
          />
        )}
      </TableContainer>
      <CustomShowModal
        open={isStepperOpen}
        handleClose={() => setInitialState()}
        title={"Create Contract"}
        maxWidth="md"
        saveLabel={"Create"}
        hideButtons={true}
      >
        <EstimateToContractStepper
          vesselFormData={vesselFormData}
          setVesselFormData={setVesselFormData}
          cargoFormData={cargoFormData}
          setCargoFormData={setCargoFormData}
          cargoAttachments={cargoAttachments}
          vesselAttachments={vesselAttachments}
          handleCargoAttachmentUpload={handleCargoAttachmentUpload}
          handleVesselAttachmentUpload={handleVesselAttachmentUpload}
          handleCargoDataChange={handleCargoDataChange}
          handleVesselDataChange={handleVesselDataChange}
          handleVesselTextContractUpload={handleVesselTextContractUpload}
          handleCargoTextContractUpload={handleCargoTextContractUpload}
          modelType={modelType}
          removeCargoAttachment={removeCargoAttachment}
          removeVesselAttachment={removeVesselAttachment}
          setCargoTextContract={setCargoTextContract}
          setVesselTextContract={setVesselTextContract}
          cargoTextContract={cargoTextContract}
          vesselTextContract={vesselTextContract}
          handleFinish={handleStepperSubmit}
          estimateFormData={estimateFormData}
          setEstimateFormData={setEstimateFormData}
        />
      </CustomShowModal>
    </Grid>
  );

  // return (
  //   <div className="request-access-container">
  //     <Paper className="request-access-wrapper" elevation={3}>
  //       <Typography className="request-access-header">Request Access All Matrix</Typography>
  //       <form onSubmit={handleSubmit}>
  //         <TextField
  //           label="Reason"
  //           variant="outlined"
  //           fullWidth
  //           multiline
  //           rows={4}
  //           className="request-access-input"
  //           value={reason}
  //           onChange={(e) => setReason(e.target.value)}
  //           placeholder="Enter your reason here"
  //         />

  //         <Button
  //           type="submit"
  //           color="primary"
  //           variant="outlined"
  //           className="font-family mt-2 px-8 rounded-md"
  //         >
  //           Submit
  //         </Button>
  //       </form>
  //     </Paper>
  //   </div>
  // );
};

export default Allmatrix;
